import { render, staticRenderFns } from "./g-live.vue?vue&type=template&id=6f0285f0&scoped=true"
import script from "./g-live.vue?vue&type=script&lang=js"
export * from "./g-live.vue?vue&type=script&lang=js"
import style0 from "./g-live.vue?vue&type=style&index=0&id=6f0285f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0285f0",
  null
  
)

export default component.exports